import React from 'react'

import Base from '../_Base'

const BrazilA14 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_a14)">
      <rect width="24" height="24" rx="2" fill="#F58220" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m17.403 8.403-1.293 4.881h1.304l.113-4.887h-.124v.006Zm-.896-1.468h2.755v6.349h1.213v1.502h-1.213v2.205h-1.91v-2.205h-2.727V13.07l1.882-6.134ZM11.626 6.935h1.706V16.99h-1.944V9.514a3.2 3.2 0 0 1-.55.454 3.424 3.424 0 0 1-.647.317V8.477c.346-.199.641-.425.885-.686.238-.255.42-.539.55-.856ZM6.88 7.037H4.909L3.524 17.065h2.767l.153-1.83h.873l.153 1.83h2.767L8.859 7.037H6.881Zm0 2.313.466 4.115h-.93L6.88 9.35Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_a14">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default BrazilA14
